const currencyEvolution = {
  euro: {
    arrow: 1,
    price: 1.17,
    origin: '',
    currency: '£/€',
  },
  dollar: {
    arrow: 1,
    price: 1.39,
    origin: '',
    currency: '£/$',
  },
};

export default currencyEvolution;
